import React, { useState, useEffect, useRef } from 'react';
import './SpeedRun.css';
import AudioPlayer from './AudioPlayer';

const SpeedRunQuestion = ({ question, answers, correctAnswer, onAnswerClick, isLocked, feedback, image, sound, mode, userAnswer }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [directAnswer, setDirectAnswer] = useState('');
  const inputRef = useRef(null);

  // Réinitialiser les états lorsque la question change ou est verrouillée
  useEffect(() => {
    setSelectedAnswer(null);
    setDirectAnswer('');
    if (mode !== 'easy' && inputRef.current && !isLocked) {
      inputRef.current.focus();
    }
  }, [question, answers, mode, isLocked]);

  const handleAnswer = (index) => {
    if (isLocked || selectedAnswer !== null) return;
    setSelectedAnswer(index);
    onAnswerClick(index);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLocked || !directAnswer.trim()) return;
    onAnswerClick(null, directAnswer.trim());
    setDirectAnswer('');
  };

  const determineClass = (index) => {
    if (selectedAnswer === null) return 'answer-button';
    if (index === correctAnswer) return 'correct-answer';
    if (index === selectedAnswer && selectedAnswer !== correctAnswer) return 'incorrect-answer';
    return 'incorrect-answer-unselected';
  };

  // Fonction pour déterminer le texte alternatif
  const getAltText = (imagePath) => {
    if (imagePath && imagePath.endsWith('.svg') && imagePath.includes('/images/Drapeau/')) {
      return 'Drapeau associé à la question';
    }
    return 'Tableau associé à la question';
  };

  // Fonction pour déterminer si l'image est un drapeau
  const isFlag = (imagePath) => {
    return imagePath && imagePath.endsWith('.svg') && imagePath.includes('/images/Drapeau/');
  };

  // Fonction pour déterminer la classe CSS en fonction du type d'image
  const getImageClass = (imagePath) => {
    return isFlag(imagePath) ? 'flag-image' : 'painting-image';
  };

  // Fonction pour déterminer la classe du conteneur
  const getFrameClass = (imagePath) => {
    return isFlag(imagePath) ? 'flag-container' : 'painting-frame';
  };

  const hasMedia = image || sound;

  return (
    <div className="speedrun-question">
      <div className={`speedrun-content ${!hasMedia ? 'no-media' : ''}`}>
        {hasMedia && (
          <div className="speedrun-media">
            {image && (
              <div className={getFrameClass(image)}>
                <img
                  src={image}
                  alt={getAltText(image)}
                  className={getImageClass(image)}
                />
              </div>
            )}
            {sound && <AudioPlayer sound={sound} />}
          </div>
        )}
        <div className="speedrun-text">
          <p className="question-text">{question}</p>
          {mode === 'easy' && answers ? (
            <ul className="answers-container">
              {answers.map((answer, index) => (
                <li
                  key={index}
                  onClick={() => handleAnswer(index)}
                  className={determineClass(index)}
                >
                  {answer}
                </li>
              ))}
            </ul>
          ) : !isLocked ? (
            <form className="answer-form" onSubmit={handleSubmit}>
              <input
                type="text"
                value={directAnswer}
                onChange={(e) => setDirectAnswer(e.target.value)}
                placeholder="Tapez votre réponse"
                className="user-answer-input"
                disabled={isLocked}
                ref={inputRef}
                autoFocus={mode !== 'easy'} // Auto-focus for direct answer modes
              />
              <button
                type="submit"
                className="submit-answer-button"
                disabled={isLocked || !directAnswer.trim()}
              >
                Vérifier
              </button>
            </form>
          ) : (
            <div className="submitted-answer">
              <p>Votre réponse : {userAnswer || 'Aucune réponse'}</p>
            </div>
          )}
        </div>
      </div>
      {feedback && (
        <div className={`answer-feedback ${feedback === 'Correct' ? 'correct' : 'incorrect'}`}>
          <p>
            <span>{feedback === 'Correct' ? '✅ Bonne réponse !' : '❌ Mauvaise réponse !'}</span>
            <br />
            <span className="feedback-info">{feedback}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default SpeedRunQuestion;